<template>
  <div>
    <slot name="activator" :open="openDialog">
      <v-btn @click="dialog = true" color="" class="" small
        ><v-icon class="mr-">mdi-printer</v-icon>Sales Invoice</v-btn
      >
    </slot>
    <v-dialog v-model="dialog" width="300" persistent>
      <v-card>
        <v-card-text class="pa-4">
          <h3 class="text--center font-weight-bold mb-4">
            Do you want to display price?
          </h3>
          <div class="d-flex justify-center">
            <v-btn @click="print_invoice(item, 1)" class="mr-2" color="primary">
              Yes
            </v-btn>
            <v-btn @click="print_invoice(item, 0)" class="mr-2" color="error">
              No
            </v-btn>
            <v-btn @click="dialog = false">Close</v-btn>
          </div>
        </v-card-text>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import printMixin from "@/mixins/printMixin";

export default {
  mixins: [printMixin],
  props: ["item"],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters({
      default_server_url: "auth/default_server_url",
    }),
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    print_invoice(item, display_price) {
      // Use text-based printing for dot matrix
      const { generateInvoiceReceipt } = require("@/utils/dotMatrixPrinter");
      const printer = generateInvoiceReceipt(item, display_price === 1);
      printer.print();
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
